<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{ $t("ROOM_INFOMATION") }}</span>
    </page-header>
    <left-menu />
    <list-room />
  </v-app>
</template>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import ListRoom from "@/components/RoomInfomation/ListRoom.vue";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    "list-room": ListRoom
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
